import styled from 'styled-components';

export const StyledDefaultBalance = styled.div<{
  playerName: any;
}>`
  display: inline-flex;
  align-items: center;
  margin-right: 4px;
  font-weight: ${({ playerName }: any) => (playerName ? 'inherit' : '600')};
  max-width: calc(100% - 16px);
  width: auto;
` as any;

export const StyledBalanceImage = styled.img`
  height: 16px;
  width: 16px;
  margin-right: 0.5em;
  background-color: transparent;
`;

export const StyledBalanceText = styled.div<{ fontSize: string }>`
  ${({ fontSize }) => fontSize && `font-size: ${fontSize};`};
` as any;
